import { productionApiUrl } from './apiOrigin';

/**
 * Where this front end talks to.
 *
 * The base URL has **no `/api` prefix**. The API mounts its routers at `/auth`
 * and `/v1` directly, which `veri-plus-backend/src/app.ts` is the proof of and
 * which the mobile app learned the hard way. `apiBaseUrl` therefore ends
 * without a trailing slash and every path starts with one.
 *
 * It is overridable at build time with `VITE_API_BASE_URL` so that a session
 * can point a preview at a local backend, and the default is production because
 * a front end that silently talks to nothing looks identical to one that works.
 *
 * `vite` in development is the exception: it defaults to the page's own
 * origin, and `vite.config.ts` proxies `/auth` and `/v1` to production.
 * Production CORS refuses every browser origin (DEFERRED 3.3), and a
 * same-origin request never asks it. See D10.
 */
export function resolveApiBaseUrl(env: {
  VITE_API_BASE_URL?: string | undefined;
  MODE: string;
}): string {
  const chosen = env.VITE_API_BASE_URL ?? (env.MODE === 'development' ? '' : productionApiUrl);
  return chosen.replace(/\/+$/, '');
}

export const apiBaseUrl = resolveApiBaseUrl(import.meta.env);
